import { PreferenceTypes } from '@mode/shared/contract-common';
import { createReducer, on, ActionReducerMap } from '@ngrx/store';
import * as PreferenceActions from './preference.actions';

export const preferenceFeatureKey = 'preference';

export interface State {
  isLoading: boolean;
  isComplete: boolean;
  error: Error | null;
  preferences: PreferenceTypes.PreferenceState | undefined;
}

export const initialState: State = {
  isLoading: false,
  isComplete: false,
  preferences: undefined, // Do we need a default preference state?
  error: null,
};

export const isCompleteReducer = createReducer(
  initialState.isComplete,
  on(PreferenceActions.loadPreferences, (state) => false),
  on(PreferenceActions.loadPreferencesSuccess, (state) => true),
  on(PreferenceActions.loadPreferencesFailure, (state) => true)
);

export const isLoadingReducer = createReducer(
  initialState.isLoading,
  on(PreferenceActions.loadPreferences, (state) => true),
  on(PreferenceActions.loadPreferencesSuccess, (state) => false),
  on(PreferenceActions.loadPreferencesFailure, (state) => false)
);

export const preferencesReducer = createReducer(
  initialState.preferences,
  on(PreferenceActions.loadPreferencesSuccess, (state, action) => action.prefs),
  on(PreferenceActions.loadPreferencesFailure, (state) => undefined)
);

export const errorReducer = createReducer(
  initialState.error,
  on(PreferenceActions.loadPreferences, (state) => null),
  on(PreferenceActions.loadPreferencesFailure, (state, action) => action.error)
);

export const reducer: ActionReducerMap<State> = {
  error: errorReducer,
  isComplete: isCompleteReducer,
  isLoading: isLoadingReducer,
  preferences: preferencesReducer,
};
